/* /* eslint-disable *\/ */
/**
 * // This file is auto-generated by Orval. Do not edit manually.
 */

/**
 * Publisher terms-and-conditions decision (separate from account verification).
 */
export type TermsAcceptanceStatusType =
  (typeof TermsAcceptanceStatusType)[keyof typeof TermsAcceptanceStatusType];

export const TermsAcceptanceStatusType = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
} as const;
